import React from 'react'
import {Category} from 'discover'
import sortedList from 'shared/sorted_category_list'

export class CategoryList extends React.Component {
  constructor(props) {
    super(props)
    this.state = { showAll: false }
  }

  static get initialLength() {
    return 12
  }

  categories() {
    const categoriesToShow = this.state.showAll ?
                          sortedList(this.props.categories) :
                          sortedList(this.props.categories).slice(0, CategoryList.initialLength)

    return categoriesToShow.map(
      category => <Category
                  url={category.url}
                  imageUrl={category.imageUrl}
                  categoryChanged={this.props.categoryChanged}
                  categoryId={category.id}
                  categoryTitle={category.name}
                  key={category.id}
                />
    )
  }

  showAllButton() {
    if (this.state.showAll) return null
    if (this.props.categories.length <= CategoryList.initialLength) return null

    return <div className='show-all-teasers'>
             <a href='#' onClick={ this.showAllButtonClicked } >
               { I18n.t('discover.categories.index.all_categories') }
             </a>
           </div>
  }

  showAllButtonClicked = (event) => {
    event.preventDefault()
    this.setState({showAll: true})
  }

  render() {
    return (
      <div className='row'>
        { this.categories() }
        { this.showAllButton() }
      </div>
    )
  }
}
